import { SHOW_HIDE_LOADER } from "./types";

export const showHideLoader = (payload) => ({
  type: SHOW_HIDE_LOADER,
  payload,
});
